<template>
  <div class="tkHotelPlanInfo tourHotelSelectRoom_topWrapper">
    <div class="tourHotelSelectRoom_hotelName">
      {{ name }}
    </div>

    <tk-star-rating
      class="tourHotelSelectRoom_rates d-flex flex-row align-items-start"
      :star-number="starNumber"
    />

    <div v-if="currentPrice" class="tourHotelSelectRoom_topInfo">
      <div class="tourHotelSelectRoom_topInfo-priceBlock">
        <p class="tourHotelSelectRoom_topInfo-text">
          <span v-if="tourFree && isGoto" class="icon_goto">
            <tk-image
              image-path="https://www.tabikobo.com/japan/images/label_goto.svg"
              alt="GOTO対象"
            />
          </span>
          {{
            tourFree
              ? '1名あたりの料金'
              : `${passengerNumber}名${nightNumber}泊合計`
          }}
        </p>
        <template v-if="isGoto">
          <div class="tourHotelSelectRoom_topInfo-text1">
            <p class="tag">支払実額</p>
            <p class="price">{{ gotoPrice }}</p>
          </div>
          <div class="tourHotelSelectRoom_topInfo-text2">
            <p class="tag">旅行代金</p>
            <p class="price">{{ tourFree ? minPrice : currentPrice }}</p>
          </div>
        </template>
        <div v-else class="tourHotelSelectRoom_topInfo-text1">
          <p class="price">{{ currentPrice }}</p>
        </div>
        <p
          v-if="tourFree"
          class="filter tourHotelSelectHotel_icontext tourHotelSelectHotel_attention"
        >
          <b>※表示価格はホテル＋航空券の合計です</b>
        </p>
      </div>
    </div>

    <tk-tripadvisor-rating
      v-if="tripadvisorInfo && Object.keys(tripadvisorInfo).length > 0"
      :review-count="tripadvisorInfo.reviewCount"
      :rating-image-url="tripadvisorInfo.ratingImageUrl"
      :rating-value="tripadvisorInfo.ratingValue"
      @clicked="tripadvisorClick"
    />
    <!-- overlap icontext when missing tripadvisor info -->
    <div
      v-else-if="isGoto"
      class="tripadvisor-wrapper in-list tripadvisor-searched"
    />
    <div class="tourHotelSelectRoom_desc tourHotelSelectRoom-pcOnly"></div>
    <div
      v-if="tourFree"
      class="tkHotelPlanInfo_favBtnArea"
    >
      <div
        v-if="showFavBalloon"
        class="tkHotelPlanInfo_favBalloon"
      >
        <tk-favorite-balloon
          :is-register="isFavoriteRegistered"
        />
      </div>
      <tk-favorite-button
        :disabled="disabledFavButton"
        :is-registered="isFavoriteRegistered"
        :not-registered-message="notRegisteredMessage"
        :registered-message="registeredMessage"
        @click="favButtonClick"
      />
    </div>
    <tk-favorite-modal
      v-if="showModal"
      :is-succeeded-register="succeededRegistration"
      :is-fav-registered="isFavoriteRegistered"
      :show-modal="showModal"
      @close="modalClosed"
    />
  </div>
</template>

<script>
import TkImage from '../../atoms/TkImage/TkImage'
import TkStarRating from '../../atoms/TkStarRating/TkStarRating'
import TkTripadvisorRating from '../../widgets/TkTripadvisorRating/TkTripadvisorRating.vue'
import TkFavoriteButton from '../../widgets/button/TkFavoriteButton/TkFavoriteButton'
import TkFavoriteBalloon from '../../atoms/TkFavoriteBalloon/TkFavoriteBalloon'
import TkFavoriteModal from '../../atoms/TkFavoriteModal/TkFavoriteModal'

export default {
  name: 'TkHotelPlanInfo',
  components: {
    TkImage,
    TkStarRating,
    TkTripadvisorRating,
    TkFavoriteButton,
    TkFavoriteBalloon,
    TkFavoriteModal,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    starNumber: {
      type: Number,
      default: 0,
    },
    isGoto: {
      type: Boolean,
      default: false,
    },
    currentPrice: {
      type: String,
      default: '',
    },
    gotoPrice: {
      type: String,
      default: '',
    },
    minPrice: {
      type: String,
      default: '',
    },
    passengerNumber: {
      type: Number,
      required: true,
    },
    nightNumber: {
      type: Number,
      required: true,
    },
    tourFree: {
      type: Boolean,
      default: false,
    },
    tripadvisorInfo: {
      type: Object,
      default: () => {},
    },
    favoriteInfo: {
      type: Object,
      default: () => {},
    },
    favRegistered: {
      type: Boolean,
      default: false,
    },
    disabledFavButton: {
      type: Boolean,
      default: false,
    },
    succeededRegistration: {
      type: Boolean,
      default: false,
    },
    showModal: {
      type: Boolean,
      default: false,
    },
    showFavBalloon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notRegisteredMessage: 'この組み合わせを保存',
      registeredMessage: 'この組み合わせを削除',
      isFavoriteRegistered: false,
    }
  },
  watch: {
    favRegistered() {
      this.isFavoriteRegistered = this.favRegistered
    },
  },
  methods: {
    tripadvisorClick() {
      this.$emit('tripadvisor-clicked')
    },
    favButtonClick() {
      this.$emit('fav-button-clicked', this.favoriteInfo)
    },
    // 以下のmethodsはお気に入りボタン押下時のモーダル表示を切り替えるために使われる
    modalClosed(){
      this.$emit('modal-closed')
    },
  },
}
</script>

<style lang="scss">
.tkHotelPlanInfo_favBtnArea {
  position: relative;
  width: auto;
}
.tkHotelPlanInfo_favBalloon {
  position: absolute;
  top: -40px;
  left: 60px;
}
</style>
